














import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MpCard from '@/components/controls/mp-card/MpCard.vue';
import { KeyValuePair } from '@/connectors/kvp.model';
import VueApexCharts from 'vue-apexcharts/typings/vue-apexcharts';
@Component({
  components: { MpCard }
})
export default class MpBundleViewsByParticipantTypeCard extends Vue {
  de = require('apexcharts/dist/locales/de.json');

  @Prop()
  value!: Array<KeyValuePair<string, number>>;

  @Prop({ default: '' })
  height!: string;

  get chartHeight(): number {
    return parseInt(this.height, 10) - 20;
  }

  isReady: boolean = false;

  get chartOptions(): any {
    return {
      chart: {
        offsetY: -10,
        locales: [this.de],
        defaultLocale: 'de',
        toolbar: {
          show: true
        }
      },
      labels: this.value.map(kvp => kvp.key),
      theme: {
        monochrome: {
          enabled: true,
          color: '#589bad',
          shadeTo: 'dark',
          shadeIntensity: 0.65
        }
      },
      dataLabels: {
        enabled: true
      },
      // colors: ['#d0c6a3', '#589bad', '#9b9b9b'],
      stroke: {
        show: false,
        curve: 'smooth',
        lineCap: 'butt',
        colors: undefined,
        width: 0,
        dashArray: 0
      },
      legend: {
        offsetY: 0,
        width: 220,
        labels: {
          colors: ['#000000'],
          useSeriesColors: false
        },
        position: 'right'
      },
      plotOptions: {
        pie: {
          size: undefined,
          customScale: 1,
          offsetX: 0,
          offsetY: 0,
          expandOnClick: true,
          dataLabels: {
            offset: -10
          }
        }
      }
    };
  }

  series: any[] = [];

  @Watch('value')
  onValueChanged() {
    this.series = this.value.map(kvp => kvp.value);
  }

  async mounted() {
    this.isReady = false;
    this.series = this.value.map(kvp => kvp.value);
    this.isReady = true;
  }
}
